import { Navigate, Route, Routes } from "react-router-dom";

import AmountLimitsPage from "./pages/AmountLimitsPage";
import DepositClabesPage from "./pages/DepositClabesPage";
import DepositCvusPage from "./pages/DepositCvusPage";
import PaymentFeeRulePage from "./pages/PaymentFeeRulePage";
import PaymentFeesPage from "./pages/PaymentFeesPage";
import PaymentTaxesPage from "./pages/PaymentTaxesPage";
import ProviderRoutesPage from "./pages/ProviderRoutesPage";
import RailAvailabilityPage from "./pages/RailAvailabilityPage";
import RateProviderUsagePage from "./pages/RateProviderUsagePage";

/**
 * Sub-router for `/app/payments-config/*` — internal (staff) configuration surfaces of the payments runtime:
 * the rail availability kill-switch, the per-transaction amount limits, the provider routes, the fee price
 * book, deposit CLABEs (Mexico SPEI) and deposit CVUs (Argentina CBU/CVU).
 *
 * The order is upstream-first. `rails` sits above everything: a disabled rail refuses creation on its
 * corridors whatever the route says. `limits` sits right under it: both gate creation before routing is
 * consulted. Then `routes` — a route is what makes a corridor exist at all, and the price book reads that
 * same catalog to know what there is to price. Then `fees`, the most consequential of the rest — a corridor
 * with no fee rule refuses every payin and payout, whereas a missing deposit account only affects one
 * organization.
 *
 * The fallback still lands on `fees`: every sidebar entry links to its own absolute path, so this only
 * catches a hand-typed or stale `/app/payments-config/...` URL, and the price book is the safer place to
 * land.
 */
export const PaymentsConfigNavigation = () => {
  return (
    <Routes>
      {/* Upstream even of routes: a disabled rail refuses creation on the corridor whatever its route says. */}
      <Route path="rails" element={<RailAvailabilityPage />} />
      <Route path="limits" element={<AmountLimitsPage />} />
      <Route path="routes" element={<ProviderRoutesPage />} />
      <Route path="fees" element={<PaymentFeesPage />} />
      <Route path="fees/rules/new" element={<PaymentFeeRulePage />} />
      {/* On top of the price book: what each corridor charges besides the commission. */}
      <Route path="taxes" element={<PaymentTaxesPage />} />
      <Route path="deposit-clabes" element={<DepositClabesPage />} />
      <Route path="deposit-cvus" element={<DepositCvusPage />} />
      {/* Observability, not configuration: it reads what the priority env already resolved to. */}
      <Route path="rate-providers" element={<RateProviderUsagePage />} />
      <Route path="*" element={<Navigate to="/app/payments-config/fees" replace />} />
    </Routes>
  );
};
